var spinCoords = {x: 737, y: 537},
    autoCoords = {x: 669, y: 548},
    betCoords = {x: 616, y: 548},
    plus_y = 551,
    label_y = 549,
    text_y = 572;


module.exports = {

    main_panel: {
        frame: 'main_panel.png',
        position:{x:56, y:541},
    },

    progressive_jackpot_panel: {
        position:{x:180, y:518},
        coin : [
             36,
             9,
        ],
        banknotes : [
             141,
             9,
        ],
        diamonds : [
             242,
             9,
        ],
        starts : [
             344,
             9,
        ],
        background : 'jp_ingame_panel.png',
    },

    common: {
        font:'userinterface_new-font'
    },

    buttons: {
        spin: {
            frames:{
                normal:'spin_normal.png',
                pressed:'spin_pressed.png',
                disabled:'spin_normal.png',
                hover: 'spin_normal.png'
            },
            hitArea:'circle',
            position:{x:spinCoords.x, y:spinCoords.y}
        },

        collect: {
            frames:{
                normal:'collect_normal.png',
                pressed:'collect_pressed.png',
                disabled:'collect_normal.png',
                hover: 'collect_normal.png'
            },
            hitArea:'circle',
            position:{x:spinCoords.x, y:spinCoords.y}
        },

        stop: {
            frames:{
                normal:'stop_normal.png',
                pressed:'stop_pressed.png',
                disabled:'stop_disabled.png',
                hover: 'stop_normal.png'
            },
            hitArea:'circle',
            position:{x:spinCoords.x, y:spinCoords.y}
        },

        start: {
            frames:{
                normal:'start_normal.png',
                pressed:'start_pressed.png',
                disabled:'start_disabled.png',
                hover: 'start_normal.png'
            },
            hitArea:'circle',
            position:{x:spinCoords.x, y:spinCoords.y}
        },

        finish: {
            frames:{
                normal:'finish_normal.png',
                pressed:'finish_pressed.png',
                disabled:'finish_disabled.png',
                hover: 'finish_normal.png'
            },
            hitArea:'circle',
            position:{x:spinCoords.x, y:spinCoords.y}
        },

        info: {
            frames:{
                normal:'info_normal.png',
                pressed:'info_pressed.png',
                disabled:'info_disabled.png',
                hover: 'info_normal.png'
            },
            hitArea:'circle',
            position:{x:39, y:512}
        },

        sound_on: {
            frames:{
                normal:'sound_off.png',
                pressed:'sound_off.png',
                disabled:'sound_off.png',
                hover: 'sound_off.png'
            },
            hitArea:'circle',
            position:{x:719, y:512}
        },

        sound_off: {
            frames:{
                normal:'sound_on.png',
                pressed:'sound_on.png',
                disabled:'sound_on.png',
                hover: 'sound_on.png'
            },
            hitArea:'circle',
            position:{x:719, y:512}
        },

        gamble: {
            frames:{
                normal:'gamble_normal.png',
                pressed:'gamble_pressed.png',
                disabled:'gamble_disabled.png',
                hover: 'gamble_normal.png'
            },
            position:{x:autoCoords.x, y:autoCoords.y}
        },

        betmax: {
            frames:{
                normal:'bet_max_normal.png',
                pressed:'bet_max_pressed.png',
                disabled:'bet_max_normal.png',
                hover: 'bet_max_normal.png'
            },
            position:{x:betCoords.x, y:betCoords.y}
        },

        betmin: {
            frames: {
                normal: 'bet_min_normal.png',
                pressed: 'bet_min_pressed.png',
                disabled: 'bet_min_normal.png',
                hover: 'bet_min_normal.png'
            },
            position:{x:betCoords.x, y:betCoords.y}
        },

        autoplay: {
            frames:{
                normal:'autoplay_normal.png',
                pressed:'autoplay_on.png',
                disabled:'autoplay_normal.png',
                hover: 'autoplay_normal.png'
            },
            position:{x:autoCoords.x, y:autoCoords.y}
        },

        autoplayoff: {
            frames:{
                normal:'autoplay_on.png',
                pressed:'autoplay_on.png',
                disabled:'autoplay_disabled.png',
                hover: 'autoplay_on.png'
            },
            position:{x:autoCoords.x, y:autoCoords.y}
        },

        menu: {
            frames:{
                normal:'lobby_normal.png',
                pressed:'lobby_pressed.png',
                disabled:'lobby_disabled.png',
                hover: 'lobby_normal.png'
            },
            hitArea:'circle',
            position:{x:1, y:spinCoords.y}
        },

        decrease_lines: {
            frames:{
                normal:'minus_normal.png',
                pressed:'minus_pressed.png',
                disabled:'minus_disabled.png',
                hover: 'minus_normal.png'
            },
            hitArea:'circle',
            position:{x:73, y:plus_y}
        },

        increase_lines: {
            frames:{
                normal:'plus_normal.png',
                pressed:'plus_pressed.png',
                disabled:'plus_disabled.png',
                hover: 'plus_normal.png'
            },
            hitArea:'circle',
            position:{x:154, y:plus_y}
        },

        lines: {
            frames:{
                normal:'lines_normal.png',
                pressed:'lines_pressed.png',
                disabled:'lines_disabled.png',
                hover: 'lines_normal.png'
            },
            position:{x:99, y:label_y}
        },

        decrease_linebet: {
            frames:{
                normal:'minus_normal.png',
                pressed:'minus_pressed.png',
                disabled:'minus_disabled.png',
                hover: 'minus_normal.png'
            },
            hitArea:'circle',
            position:{x:201, y:plus_y}
        },

        increase_linebet: {
            frames:{
                normal:'plus_normal.png',
                pressed:'plus_pressed.png',
                disabled:'plus_disabled.png',
                hover: 'plus_normal.png'
            },
            hitArea:'circle',
            position:{x:289, y:plus_y}
        },

        linebet: {
            frames:{
                normal:'line_bet_normal.png',
                pressed:'line_bet_pressed.png',
                disabled:'line_bet_disabled.png',
                hover: 'line_bet_normal.png'
            },
            position:{x:229, y:label_y}
        },
        next: {
            frames: {
                normal:"next_normal.png",
                hover: 'next_hover.png',
                pressed:"next_pressed.png",
                disabled:"next_disabled.png"
            },
            position:{x:640,y:545}
        },
        exit: {
            frames: {
                normal:"exit_normal.png",
                hover: 'exit_hover.png',
                pressed:"exit_pressed.png",
                disabled:"exit_disabled.png"
            },
            position:{x:322, y:545}
        },
        back: {
            frames: {
                normal:"back_normal.png",
                hover: 'back_hover.png',
                pressed:"back_pressed.png",
                disabled:"back_disabled.png"
            },
            position:{x:10, y:545}
        }
    },

    frames: {
        lines:{
            frame:'',
            text_position:{x:3, y:4},
            text_align:{x:0.5, y:0.5},
            position:{x:130, y:text_y}
        },

        line_bet:{
            frame:'',
            text_position:{x:2, y:4},
            text_align:{x:0.5,y:0.5},
            position:{x:261, y:text_y}
        },

        win:{
            frame:'ui_win_label.png',
            font: 'userinterface_win-font',
            text_position:{x:34, y:29},
            text_align:{x:0.5, y:0.5},
            position:{x:365, y:545}
        },

        credits:{
            frame:'credits.png',
            text_position:{x:33, y:text_y - label_y + 4},
            text_align:{x:0.5, y:0.5},
            position:{x:539, y:label_y}
        },

        credits_risk:{
            frame:'credits_risk.png',
            text_position:{x:73, y:35},
            text_align:{x:0.5, y:0.5},
            position:{x:324, y:541}
        },

        total_bet:{
            frame:'total_bet.png',
            text_position:{x:35, y:text_y - label_y + 4},
            text_align:{x:0.5, y:0.5},
            position:{x:463, y:label_y}
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/library/cfg/userinterface-config_800x600.js
// module id = 118
// module chunks = 0